import { render, staticRenderFns } from "./SalaryChart.vue?vue&type=template&id=a9ae7a14&"
import script from "./SalaryChart.vue?vue&type=script&lang=js&"
export * from "./SalaryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports